import { appConstants } from "JS/Helpers/Constants";
import { BaseService } from "../BaseService";
import { config } from "JS/Config";

class ContentUpdateService extends BaseService {
    getContentUpdate = (contentType: string, contentCachedTime: number) =>
        this.ngCall<boolean>(
            "get",
            appConstants?.ngEndpoints?.contentUpdate(config?.user?.memberId),
            {
                params: {
                    contentType,
                    contentCachedTime,
                },
            },
        );
}

export default ContentUpdateService;
